// extracted by mini-css-extract-plugin
export default {"backSpan":"wVZ72","backArrow":"ipFvP"};